function initMap() {
    const brentwoodClub = {lat: 51.6348739, lng: 0.2975288};
    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 15,
        center: brentwoodClub,
    });
    const marker = new google.maps.Marker({
        position: brentwoodClub,
        map: map,
    });
}

window.initMap = initMap;